import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { useLocation } from 'react-router-dom'
import ErrorPage from '../ErrorPage/ErrorPage'
import errorTrackingService from '../../../services/errorTrackingService'

const AppErrorBoundary = ({ children, _internalLabel }) => {
  const location = useLocation()

  const excludedRoutes = [
    '/login',
    '/callback',
    '/signup',
    '/reset-password',
    '/verify-email'
  ]

  const shouldExclude = excludedRoutes.some(route =>
    location.pathname.startsWith(route)
  )

  const handleError = (error, errorInfo) => {
    const errorId = `${Date.now()}-${Math.random().toString(36).substring(2, 11)}`

    // Solo trackear errores JavaScript (los API ya se trackean en el provider)
    if (!error.isAPIError) {
      errorTrackingService.trackJavaScriptError(error, {
        ...errorInfo,
        errorId,
        pathname: location.pathname,
        search: location.search,
        error_label: _internalLabel || 'Unknown Component'
      })
    } else if (error.isAPIError && error.endpoint?.includes('/calendar/')) {
      // Caso especial: errores de calendar con evento personalizado
      errorTrackingService.trackAPIError(error, error.endpoint, error.method, 'Calendar_Fetch_Error', {
        error_label: _internalLabel || 'Unknown Component'
      })
    }

    console.error('Error capturado por ErrorBoundary:', error)
    console.error('Información adicional:', errorInfo)
    if (_internalLabel) {
      console.error('Componente:', _internalLabel)
    }
  }

  const ErrorFallback = ({ error, resetErrorBoundary }) => {
    return <ErrorPage error={error} resetError={resetErrorBoundary} />
  }

  if (shouldExclude) {
    return <>{children}</>
  }

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={handleError}
      resetKeys={[location.pathname]}
    >
      {children}
    </ErrorBoundary>
  )
}

export default AppErrorBoundary
